(function(angular){
	'use strict';

	angular.module('existingUserOnboardingModule', [
		'affixModule',
		'apiModule',
		'coreModule',
		'goalTeaserModule',
		'ngMessages',
		'portfolioAllocationChartModule',
		'slideModule'
	]);
})(window.angular);